import {
  ComponentsOverrides,
  ComponentsProps,
  ComponentsVariants,
  Theme,
} from '@mui/material';

type MuiRadio = {
  styleOverrides?: ComponentsOverrides<Theme>['MuiRadio'];
  defaultProps?: ComponentsProps['MuiRadio'];
  variants?: ComponentsVariants['MuiRadio'];
};

export const MuiRadio: MuiRadio = {
  defaultProps: {
    color: 'primary',
  },
  styleOverrides: {
    colorPrimary: {
      color: '#0066ED',
      '&.Mui-checked': {
        color: '#0066ED',
      },
    },
  },
};
